import {
  INTEGRATION_CODE_FETCH_REQUEST,
  INTEGRATION_CODE_TYPE_CLEAN_REQUEST,
  INTEGRATION_CODE_TYPE_FETCH_REQUEST_FAILURE,
  INTEGRATION_CODE_TYPE_FETCH_REQUEST_SUCCESS,
} from 'constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

const integrationCodeTypesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case INTEGRATION_CODE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case INTEGRATION_CODE_TYPE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    case INTEGRATION_CODE_TYPE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case INTEGRATION_CODE_TYPE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });
    default:
      return state;
  }
};

export default integrationCodeTypesReducer;
